import { render, staticRenderFns } from "./Whistleblower.vue?vue&type=template&id=d4feb5d0"
import script from "./Whistleblower.vue?vue&type=script&lang=js"
export * from "./Whistleblower.vue?vue&type=script&lang=js"
import style0 from "./Whistleblower.vue?vue&type=style&index=0&id=d4feb5d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports